"use client";

// کلاس‌ها و متن‌های فیلدهای فرم هسته (SelectBoxInput هسته به‌جای کپی قبلی components/ui/SelectBoxInput.jsx).
// کلاس‌ها اینجا می‌مانند تا Tailwind سایت آن‌ها را ببیند.
import { useTranslations } from "next-intl";
import { Search, X } from "lucide-react";
import CheckBox from "@/components/ui/CheckBox";
import { FormFieldsProvider } from "@core/helpers/client/contexts/FormFieldsContext";

export const form_fields = {
  select_box_input: {
    // t همان‌جا که فیلد رندر می‌شود خوانده می‌شود (provider نزدیک‌تر)
    useTranslate: useTranslations,
    texts: (t) => ({
      choose: t("choose") || "انتخاب کنید",
      search_placeholder: "جستجو کنید",
      nothing_found: "موردی یافت نشد",
      clear_search: "پاک کردن جستجو",
      remove_item: (name) => `حذف ${name}`,
    }),
    translate_option_labels: true,
    dir: "rtl",
    menu_style: { direction: "rtl" },
    error_tag: "div",
    flip_menu_height: (searchable) => 45 * 4 + 16 + (searchable ? 40 : 0) + 8,
    option_checkbox: CheckBox,
    icons: {
      search: <Search className="w-4 h-4 shrink-0 text-jmt-neutral-400" />,
      clear: <X size={16} className="text-jmt-neutral-400 hover:text-jmt-neutral-600" />,
      chip_remove: <X size={12} className="text-jmt-neutral-600" />,
    },
    classNames: {
      root: "relative w-full mx-auto",
      label_parent: "w-full flex items-center justify-between gap-1 min-h-5 mb-1.5",
      label: "relative text-sm font-medium",
      label_enabled: "text-jmt-main",
      label_disabled: "text-jmt-neutral-500",
      required: "absolute top-0 -left-2 text-jmt-red-500",
      box: "flex items-center w-full border rounded-md overflow-hidden transition-all duration-150",
      box_error: "border-red-500",
      box_disabled: "bg-jmt-neutral-50 border-jmt-neutral-200 cursor-not-allowed",
      box_open: "border-jmt-neutral-600",
      box_closed: "border-jmt-neutral-300 hover:border-jmt-neutral-500",
      trigger_single: "w-full flex items-center justify-between bg-transparent outline-0 text-sm py-2 px-3 min-h-9 text-right",
      trigger_multi: "w-full flex items-center justify-between gap-2 bg-transparent outline-0 text-sm min-h-9 text-right",
      trigger_multi_filled: "py-1.5 ps-1.5 pe-3",
      trigger_multi_empty: "py-2 px-3",
      trigger_enabled: "cursor-pointer",
      trigger_disabled: "text-jmt-neutral-500 cursor-not-allowed",
      value_text: "truncate text-jmt-main text-sm",
      value_text_selected: "",
      value_text_placeholder: "",
      placeholder: "truncate text-jmt-main text-sm",
      arrow: "w-4 h-4 text-jmt-neutral-600 transition-transform duration-200 mr-2 shrink-0",
      arrow_open: "rotate-180",
      chips: "flex min-w-0 flex-1 items-center gap-1 overflow-hidden",
      chip: "rounded-sm bg-jmt-neutral-100 px-1.5 py-0.5 text-xs leading-4 text-jmt-main",
      chip_item: "flex min-w-0 items-center gap-1",
      chip_text: "truncate",
      chip_remove: "flex shrink-0 items-center justify-center cursor-pointer",
      chip_more: "shrink-0",
      meter: "pointer-events-none invisible absolute inset-x-0 top-0 h-0 overflow-hidden",
      meter_row: "flex w-max items-center gap-1 whitespace-nowrap",
      meter_chip: "flex items-center gap-1",
      meter_icon: "size-3",
      menu: "absolute z-30 w-full bg-jmt-white border border-jmt-neutral-200 rounded-md shadow-sm overflow-hidden text-right",
      menu_down: "mt-1",
      menu_up: "bottom-full mb-1",
      search_row: "flex items-center gap-2 px-2 py-1.5 border-b border-jmt-neutral-100",
      search_input: "w-full bg-transparent outline-0 text-sm text-jmt-main placeholder:text-jmt-neutral-400 placeholder:text-[13px]",
      clear_button: "flex items-center justify-center cursor-pointer",
      list: "p-1 max-h-45 overflow-y-auto custom-scrollbar",
      placeholder_item: "p-2 text-sm text-jmt-main rounded-md cursor-pointer hover:bg-jmt-neutral-100 transition-colors",
      option: "p-2 text-sm text-jmt-main rounded-md cursor-pointer hover:bg-jmt-neutral-100 transition-colors",
      option_selected: "font-bold",
      option_unselected: "",
      option_multi: "p-2 rounded-md cursor-pointer hover:bg-jmt-neutral-100 transition-colors",
      option_multi_selected: "",
      option_multi_unselected: "",
      option_checkbox: "pointer-events-none",
      empty: "p-2 text-sm text-jmt-neutral-400 text-center",
      error: "absolute text-[10px] flex ms-2 text-jmt-red-500 animate-fade mt-1",
    },
  },
};

const FormFields = ({ children }) => <FormFieldsProvider value={form_fields}>{children}</FormFieldsProvider>;

export default FormFields;
